module.exports = __webpack_public_path__ + "387b3cfefb350373d52fd5a508491000.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_60.mp3
// module id = 461
// module chunks = 0